// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"752d59bf","977":"925d5479"}[chunkId] + ".chunk.js";
};